<template>
    <form @submit.prevent class="login">

        <h3 class="headline">{{localizeList.logInUpper}}</h3>

        <form-input v-model="loginForm.login.value"
                    @focus="changeTabPosition(0)"
                    :valid="loginForm.login.isValid"
                    :autofocus="isAutofocus"
                    :error="loginForm.login.errorText"
                    :label="localizeList.userName"
                    :parent-focus="tabPosition === 0"/>

        <div class="input-wrap">
            <form-input v-model="loginForm.password.value"
                        @focus="changeTabPosition(1)"
                        :valid="loginForm.password.isValid"
                        :error="loginForm.password.errorText"
                        type="password"
                        :label="localizeList.passwordUpper"
                        :parent-focus="tabPosition === 1"/>
            <a ref="tabPosition_2"
               :href="passwordRecoveryHref"
               class="forgot-password">
                {{localizeList.forgotPassword}}
            </a>
        </div>

        <checkbox v-if="!this.openLoginModalFromBasket" 
                  small class="mb-10 authenticated-checkbox"
                  v-model="redirectPA"
                  :label="localizeList.openDashboard"
                  :parent-focus="tabPosition === 3"/>

        <div class="align-center justify-between">
            <div class="registration-btn-group">
                <a class="block" ref="tabPosition_4"
                   :href="registrationHref">
                    {{localizeList.agencyRegistration}}
                </a>
                <a v-show="showTouristRegistration"
                   ref="tabPosition_5"
                   class="block pointer mt-3"
                   href=""
                   @click.prevent="toggleRegistration()">
                    {{localizeList.touristRegistration}}
                </a>
            </div>

            <div class="login-btn-group">

                <base-button @click.native="login()"
                            @keypress.enter="login()"
                            :disabled="loginLoaderStatus"
                            padding="10px 48px"
                            :parent-focus="tabPosition === 6">
                    <span v-if="!loginLoaderStatus" class="login-btn">
                        {{ loginBtnText }}
                    </span>
                    <base-loader v-else size="16" weight="5"/>
                </base-button>

                <base-button v-if="this.openLoginModalFromBasket && isSettingsNoRegistration" 
                            @click.native="withoutLogin()"
                            @keypress.enter="withoutLogin()"
                            :disabled="loginLoaderStatus"
                            padding="10px 48px"
                            :parent-focus="tabPosition === 6">
                    <span v-if="!loginLoaderStatus" class="login-btn">
                        {{ this.localizeList.noRegisterBooking  }}
                    </span>
                    <base-loader v-else size="16" weight="5"/>
                </base-button>

             </div>
        </div>

        <div v-show="loginWarningShow" class="login-warning-block">
            <icon name="warning" width="16px" height="16px" fill="#DA0000"/>
            <p class="ml-4">{{ loginForm.errorResponse }}</p>
        </div>
    </form>
</template>

<script>
    import * as GTM from "@/plugins/GTM.js";
    import * as methods from "@/plugins/methods.js";
    import {bus} from '../../../main.js'
    import * as mTypesTour from "@/stores/modules/tour/mutation_types"

    export default {
        name: "login",
        props: {
            tabPosition: {
                type: Number,
                default: 0
            },
            loginModal: {
                type: Boolean,
                default: false
            },
            isAutofocus: {
                type: Boolean,
                default: false
            },
            openLoginModalFromBasket: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loginForm: {
                    login: {
                        value: "",
                        isValid: true,
                        errorText: ""
                    },
                    password: {
                        value: "",
                        isValid: true,
                        errorText: ""
                    },
                    errorResponse: "",
                },
                redirectPA: false,
                loginWarningShow: false,
                passwordRecoveryUrl: null,
                registrationUrl: null,
            }
        },
        computed: {
            loginLoaderStatus: {
                get: function (){
                    return this.loading;
                },
                set: function (value){
                    this.$emit('change-loading', value)
                }
            },
            isSettingsNoRegistration() {
                return this.$store.getters['common/getIsSettingsNoRegistration']
            },
            showTouristRegistration() {
                return window.settings.showTouristRegistration || window.settings.showTouristRegistration === undefined
            },
            loginBtnText() {
                return this.openLoginModalFromBasket ? this.localizeList.registerBooking : this.localizeList.logInUpper
            },
            registrationHref() {
                return `${this.registrationUrl}?ReturnUrl=${this.locationHref}`
            },
            passwordRecoveryHref() {
                return `${this.passwordRecoveryUrl}?ReturnUrl=${this.locationHref}`
            },
            locationHref() {
                return location.href
            },
        },
        created() {
            bus.$on("isAuthenticated", val => {
                this.$store.commit("tour/" + mTypesTour.M_SET_IS_AUTHENTICATED_RECENTLY, val);
                // Logout
                if (!val) {
                    this.loginForm.login.errorText = "";
                    this.loginForm.login.isValid = true;

                    this.loginForm.password.errorText = "";
                    this.loginForm.password.isValid = true;
                    this.loginWarningShow = false;
                }
            });

            bus.$on("login-from-out", form => {
               this.login(form);
            });

            bus.$on("check-warning-and-ban", async (cb) => {
               const warningAndBan = await this.checkWarningAndBan();
               cb(warningAndBan)
            });

            window.addEventListener("keyup", this.keyup);
        },
        mounted() {
            this.passwordRecoveryUrl = this.$store.state.passwordRecoveryUrl;
            this.registrationUrl = this.$store.state.registrationUrl;
            this.loginForm.errorResponse = this.localizeList.loginError;
        },
        methods: {
            async checkWarningAndBan() {
                const result = {banText: '', warningText: ''}

                const userInfo = methods.getCookieValueByName('CommonApplicationAuthCookie_.masterweblight-auth')
                const userKey = userInfo ? JSON.parse(userInfo).UserKey : null

                if (userKey === null) return result

                const res = await this.$store.dispatch("common/A_GET_WARNING_AND_BAN_USER", userKey)
                if (!res.length) return result

                let banText = ""
                let warningText = ""
                res.map((x) => {
                  if (x.First === 1) banText += x.Second
                  else if (x.First === 2) warningText += x.Second
                  return x
                })
                result.banText = banText
                result.warningText = warningText

                return result
            },
            keyup(e) {
                if (this.loginModal && e.keyCode === 13 && !this.loginLoaderStatus) {
                    if (this.tabPosition === 0 || this.tabPosition === 1 || this.tabPosition === 6) {
                        this.login()
                    }
                    if (this.tabPosition === 2 || this.tabPosition === 4 || this.tabPosition === 5) {
                        this.$refs[`tabPosition_${this.tabPosition}`].click()
                    }
                }
            },
            toggleRegistration() {
                this.$refs["tabPosition_5"]?.classList.remove("focus");

                this.$emit("toggleRegistration")
            },
            changeTabPosition(i) {
                this.$emit("changeTabPosition", i)
            },
            resetForm() {
                this.loginForm.login.isValid = true;
                this.loginForm.password.isValid = true;
                this.startLoginValid = true;
                this.loginForm.login.value = "";
                this.loginForm.login.errorText = "";
                this.loginForm.password.value = "";
                this.loginForm.password.errorText = "";
                this.$emit("resetForm")
            },
            loginValid() {
                let valid = true;
                if (!this.loginForm.login.value.length) {
                    this.loginForm.login.errorText = "enterLogin";
                    this.loginForm.login.isValid = false;
                    valid = false;
                }
                if (!this.loginForm.password.value.length) {
                    this.loginForm.password.errorText = "enterPassword";
                    this.loginForm.password.isValid = false;
                    valid = false;
                }

                return valid
            },

            withoutLogin() {
                this.loginWarningShow = false;
                this.loginLoaderStatus = false;
                if (this.openLoginModalFromBasket) {
                    bus.$emit('buyTourNoRegistration');
                }
                bus.$emit('isAuthenticated', false);
            },
            login(form) {
                this.loginLoaderStatus = true;
                this.startLoginValid = true;
                bus.$emit('isProcessingAuth', true);

                if (!this.loginValid() && !form) {
                    this.loginLoaderStatus = false;
                    bus.$emit('isProcessingAuth', false);
                    return
                } 

                let formData = {
                    login: this.loginForm.login.value,
                    password: this.loginForm.password.value
                };
                if (form) {
                    formData = form
                }

                this.$store.dispatch("tour/A_SIGN_IN", formData)
                    .then(async res => {
                        const warningAndBan = await this.checkWarningAndBan();
                        if (warningAndBan.warningText) {
                          const confirmWarning = this.localizeList.partnerWarningText.replace("{0}", warningAndBan.warningText)
                          alert(confirmWarning)
                        }

                        // Google Tag Manager
                        GTM.login(this.loginForm.login.value);
                        // End Google Tag Manager

                        const notification = res.data.Notifications;
                        if (notification.length) {
                            let text = notification[0].replace(/(<([^>]+)>)/ig, "");

                            // Конвертируем символы
                            const div = document.createElement("div");
                            div.innerHTML = text;
                            text = div.innerText;

                            alert(text)
                        }

                        this.resetForm();
                        this.loginWarningShow = false;
                        this.loginLoaderStatus = false;
                        if (this.redirectPA) {
                            location.href = `${this.$store.state.orderListUrl}`
                        }
                        this.$emit("login");
                        if (this.openLoginModalFromBasket) {
                            bus.$emit('buyTour');
                        }
                        bus.$emit('isAuthenticated', true);
                    })
                    .catch((err) => {
                        this.loginForm.errorResponse = err.data.replace(/\[.+\]/, (x) => this.localizeList[x.slice(1, -1)])
                        // if (err.data) this.loginForm.errorResponse = this.localizeList.partnerBanText.replace("{0}", err.data)
                        // else this.loginForm.errorResponse = this.localizeList.loginError

                        this.loginLoaderStatus = false;
                        this.loginWarningShow = true;

                        bus.$emit('isProcessingAuth', false);
                        this.$emit("loginWarning")
                    })
            },
        },
        beforeDestroy() {
            window.removeEventListener("keyup", this.keyup);
        },
        watch: {
            "loginForm.login.value"(val) {
                if (val.length) {
                    this.loginForm.login.isValid = true;
                } else if (this.startLoginValid) {
                    this.loginForm.login.isValid = false;
                    this.loginForm.login.errorText = "enterLogin";
                }
            },
            "loginForm.password.value"(val) {
                if (val.length) {
                    this.loginForm.password.isValid = true;
                } else if (this.startLoginValid) {
                    this.loginForm.password.isValid = false;
                    this.loginForm.password.errorText = "enterPassword";
                }
            },
            tabPosition(val) {
                this.$refs[`tabPosition_${val - 1}`]?.classList.remove("focus");
                this.$refs[`tabPosition_${val}`]?.classList.add("focus");
            },
        }
    }
</script>

<style scoped>

    .headline {
        margin: 0 0 15px 0;
        font-weight: 500;
        font-size: 28px;
        line-height: 33px;
        color: #1D1D1D;
    }

    .input-wrap {
        position: relative;
        margin-bottom: 25px;
    }

    .input-wrap .forgot-password {
        position: absolute;
        bottom: 8px;
        right: 0;
        font-size: 12px;
        line-height: 14px;
        color: var(--lighten-5-color);
        cursor: pointer;
        text-decoration: none;
    }

    .login-warning-block {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        line-height: 15px;
        color: #DA0000;
        background-color: rgba(218, 0, 0, 0.1);
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 14px;
    }

    .registration-btn-group {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--primary-color);
    }

    .registration-btn-group a {
        text-decoration: none;
        color: var(--primary-color);
    }

    .login-btn-group {
      display: flex; 
      flex-direction: column; 
      gap: 10px;
    }

    .login-btn {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
    }

    a.focus {
        outline: #000 auto 1px;
    }

    /deep/ .authenticated-checkbox.c-checkbox.focus {
        outline: 2px solid black;
    }

</style>